import { api } from "shared/redux/api";

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSSToken: build.query({
      query: () => {
        return {
          url: `/private/ss/v1/token`,
        };
      },
      transformResponse: (response) => {
        return response?.data;
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetSSTokenQuery, useLazyGetSSTokenQuery } = injectedRtkApi;
